import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { _LiveTvChannelLists, _LiveTvSelectedChannelList } from "./optics";
const LiveChannelListView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const listOfLiveChannels = Fold.toArray(_LiveTvSelectedChannelList, data).concat(Fold.toArray(_LiveTvChannelLists, data));
    const filteredLiveTvChanneLists = listOfLiveChannels.filter(({ id }, i, array) => array.findIndex((t) => t.id === id) === i);
    return {
        filteredLiveTvChanneLists,
    };
};
const LiveTvChannelList = ({ filteredLiveTvChanneLists }) => (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
    React.createElement(LiveChannelListView, { filteredLiveTvChanneLists: filteredLiveTvChanneLists })));
export const ComponentMapItem = mkSiteBuilderComponent(getProps, LiveTvChannelList);

